export default function obtenerModalidad(idModalidad, modalidades) {
    let modalidad = "";
    try {
        for (let i = 0; i < modalidades.length; i++) {
            if (Number(idModalidad) === modalidades[i].idModalidad){
                modalidad = modalidades[i].nombreModalidad.toUpperCase();
                break;
            } 
        }
    } catch (error) {
        console.log(error)
    }
    finally {
        return modalidad;
    }

}